import { __awaiter } from "tslib";
import axios from 'axios';
import { config } from '@/config';
export const getEnvironmentConfig = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    return (_a = (yield axios.get(`${config.value.apiEndPoint}/environment`))) === null || _a === void 0 ? void 0 : _a.data;
});
